import makeStyles from '@material-ui/core/styles/makeStyles'

export const useACHCreditStyle = makeStyles((theme) => ({
  darkTypography: {
    color: theme.palette.secondary.dark,
  },
}))
